import React from "react";
import { MainNav } from "./CompanyProfileComponents/MainNav";
import { MainRecProfessional } from "./RecruiterProfessional/MainRecProfessional";

export const RecuriterProfessional = () => {
  return (
    <view>
      <MainNav />
      <MainRecProfessional />
    </view>
  );
};
